import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs.
const ACTIONS = {
  delete: {
    confirm: (name) => ({
      title: 'Liste löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Liste wird gelöscht …',
    flash: 'liste-geloescht',
    run: (id) => http.delete(`/listenansichten/${id}`)
  }
};

export function initListeList() {
  const list = document.getElementById('liste-list');
  if (!list) return;

  const liste = initLiveList({
    results: 'liste-list',
    path: '/listen',
    forms: ['liste-filter', 'liste-search']
  });

  // Creating and editing happen in the shared dialog. The selectors are
  // anchored on '/listen/' the way jobList.js anchors on '/jobs/', so a row's
  // own outbound link to the list itself is not swallowed.
  initFormModalLinks({
    selector: 'a[href="/listen/new"], a[href^="/listen/"][href$="/edit"]',
    onSaved: () => (liste ? liste.refresh() : window.location.reload())
  });

  // One delegated listener for the whole table, so the rows arriving with each
  // refreshed fragment are live without rebinding.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { listeId, listeName } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(listeName)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(listeId);
      window.location.href = withFlash('/listen', action.flash);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
